<template>

      <v-container fluid>
        <!-- <v-row no-gutters justify="center" class="mt-n6">
          <span style="font-size: 34px; color: #616161">Descuentos</span>
        </v-row> -->
       
          <v-stepper v-model="types_form" >
            <v-btn-toggle v-model="types_form" tile color="primary" group>
            <v-btn> <v-icon class="mx-1"> group</v-icon>Descuento clientes  </v-btn>
            <v-btn><v-icon class="mx-1"> inventory_2</v-icon> Descuento productos   </v-btn> 
 
          </v-btn-toggle>
            <v-row justify="center" class="mt-2">
              <v-col cols="12" md="12">
                <v-row justify="center">
            <search-header
                class="mt-n2 mb-2"
                :show_department="false"
                :show_location="true"
                :show_accounts="false"
                :select_week="2"
                :show_payments="false"
                :show_weeks="false"
                :show_refresh="false"
                @dataFilters="searchDiscount($event, 1)"
              />
        </v-row>
              </v-col>
            </v-row>

            <v-stepper-items class="mt-n8">
              <v-stepper-content step="0" >
                <v-row justify="center" >
                  <v-card outlined>
        
            <v-card  flat class="mt-0 pt-0" width="100vw">
              <v-card-text class="mt-0 pt-0">
              <v-row>
            
              <v-col  cols="12">
                <v-data-table :headers="headerDiscount" :search="search" :items="EntitiesDiscounts" :loading="loadingEntitiesDiscounts">
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Clientes</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <span>{{ EntitiesDiscounts.length }}</span>
                      <v-spacer></v-spacer>
                      <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Buscar"
                        single-line hide-details>
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-divider class="mx-3" inset vertical></v-divider>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                    
                          <v-btn v-if="hasFeature('ING-062')" color="primary" class="mr-2" v-bind="attrs" v-on="on" outlined @click="newDiscount()">
                            Nuevo descuento
                            <v-icon>add</v-icon>
                          </v-btn>
                        </template>
                        <span>Crear nueva caja</span>
                      </v-tooltip>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.edit`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-if="hasFeature('ING-062')" v-bind="attrs" v-on="on" medium color="blue" @click="editeDiscountClient(item)">
                          edit
                        </v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.dni`]="{ item }">
                    {{  item.document_id_type_name}}  : {{ item.document_id }}
                  </template>
                  <template v-slot:[`item.range`]="{ item }">
                  Desde {{  parseFloat( item.from_percent_discount)*100 }}% hasta {{  parseFloat( item.to_percent_discount) *100  }}%
                  </template>
                  <template v-slot:[`item.default_percent`]="{ item }">
                   {{ (parseFloat( item.default_percent)*100).toFixed(0)  }}% 
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
              </v-card-text>
            </v-card>
       
     
        </v-card>
                </v-row>
              </v-stepper-content>
              <v-stepper-content step="1">
                <v-row justify="center">
                  <v-col  cols="12">
                <v-data-table :headers="headerArticles" :search="search" :items="articlesCatalogue" :loading="loadingEntitiesDiscounts">
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Productos</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <span>{{ EntitiesDiscounts.length }}</span>
                      <v-spacer></v-spacer>
                      <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Buscar"
                        single-line hide-details>
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-divider class="mx-3" inset vertical></v-divider>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-if="hasFeature('ING-062')" color="primary" class="mr-2" v-bind="attrs" v-on="on" outlined @click="newDiscount()">
                            Nuevo descuento
                            <v-icon>add</v-icon>
                          </v-btn>
                        </template>
                        <span>Crear nueva caja</span>
                      </v-tooltip>
                    </v-toolbar>
                  </template>
             
                  <template v-slot:[`item.actions`]="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    medium
                                    color="success"
                                    @click="deleteItemSelected(item)"
                                  >
                                    add
                                  </v-icon>
                                </template>
                                <span>Agregar descuento</span>
                              </v-tooltip>
                          
                            </template>
                </v-data-table>
              </v-col>
                </v-row>
              </v-stepper-content>

            </v-stepper-items>
          </v-stepper>
    
    
 
          <v-dialog v-model="dialogEdit" max-width="50%">
            <v-card outlined>
              <v-card-title class="mb-3">
             
                <span v-if="lastData.location!=null">{{ titleDialog }}     ( {{$store.state.auth.locations.find((e) => e.id == lastData.location).text}} ) </span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogEdit = false">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text v-if="!loadingEntityEdit">
                <v-container fluid>
                <v-row>
                 
                          <v-col cols="12" md="7">
                            <v-text-field
                              :rules="[(v) => !!v || 'Cliente requerido']"
                              :value="
                                selectedEntity != null
                                  ? selectedEntity.name
                                  : ''
                              "
                              dense
                              outlined
                              readonly
                              label="Cliente"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <searchClients
                              :types_clients="2"
                              @selected-item="handleEntity($event)"
                            />
                          </v-col>
                       
                </v-row>
                <v-row class="mt-n2" no-gutters justify="start">
                          <v-col cols="12" md="4">
                            <v-text-field
                              :value="
                                selectedEntity != null
                                  ? selectedEntity.document_id
                                  : ''
                              "
                              dense
                              outlined
                              readonly
                              label="RNC o Cédula"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="firstValue"
                      :items="percentageOptions"
                      label="Descuento desde "
                      item-text="label"
                      item-value="value"
                      outlined
                      @change="onFirstValueChange"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="secondValue"
                      :items="filteredPercentageOptions"
                      label="Descuento Hasta"
                      item-text="label"
                      item-value="value"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row justify="center" class="mt-n3">
                  <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="defaultValue"
          :items="defaultFilteredOptions"
          label="Descuento por defecto"
          item-text="label"
          item-value="value"
          outlined
        ></v-autocomplete>
      </v-col>
                </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text @click="saveNewDiscountClient()" :loading="loadingSave">
                  {{ nameButon }}
                </v-btn>
                <v-btn color="error" text @click="dialogEdit = false">
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      
      </v-container>

</template>
<script>
import searchClients from "../../components/Income/SearchClientOrSupplier.vue";
export default {
  components: {
    searchClients
  },
  data: () => ({
    firstValue: null,
      secondValue: null,
      defaultValue: null,

    loadingEntitiesDiscounts: false,
    types_form: 0,
    type: 1,
    loadingEntityEdit: false,
    selectedEntity: null,
    type_modal: 1,
    search: "",
    EntitiesDiscounts: [],
    discounts: [],
    articlesCatalogue: [],
    percentageOptions: Array.from({ length: 100 }, (_, i) => ({
        label: `${i + 1}%`,
        value: i + 1,
      })),
    newDiscounts: {
      name: "",
      chart_of_account_id: "",
      percent: 0.0,
      porcentaje: 0,
    },
    lastData:{},
    lastDiscount:{},
    headerArticles: [
      {
        text: "ID",
        align: "start",
        value: "item_id",
        width: "5%",
      },
      { text: "Descripción", value: "item_name", width: "15%" },
      { text: "Medida", value: "unit_name", width: "11%", align: "center" },
      { text: "Categoría", value: "item_categorie_name", width: "12%" },
       { text: "Codigo barra", value: "code", width: "8%" },
      { text: "Acciones", value: "actions", sortable: false, width: "5%" },
    ],
    headerDiscount: [
      {
        text: "ID",
        align: "start",
        value: "entity_id",
      },
      { text: "Nombre", value: "name" },
      { text: "Identificación", value: "dni" },
      { text: "Rango descuento ", value: "range" },
      { text: "Por defecto", value: "default_percent" },
      { text: "Editar", value: "edit", sortable: false },
    ],
    dialogEdit: false,
    chartOfAccount: [],
    nameButon: "",
    is_new_Withholdings: true,
    titleDialog: "",
    loadingSave: false,
  }),

  created() {
    this.initialized();
  },

  computed: {
    filteredPercentageOptions() {
      return this.percentageOptions.filter(
        (option) => option.value >= this.firstValue
      );
    },   
     defaultFilteredOptions() {
      return this.percentageOptions.filter(
        (option) => option.value >= this.firstValue && option.value <= this.secondValue
      );
    },

  },
  watch: {
    types_form() {
      this.searchDiscount(this.lastData);
    }

  },
  methods: {
    async initialized() {
      this.getData();
    },
    onFirstValueChange(value) {

      if (this.secondValue < value) {
        this.secondValue = null;
      }
    },
    handleEntity(data) {
      this.selectedEntity={}
      this.selectedEntity = data;
    },
    async searchDiscount(data) {
  
      this.lastData = data
      if(data.business==0 || data.business==null || data.business==undefined){
        this.$toast.warning("Selecciona una unidad de negocio")
        return
      }
      if(data.location==0 || data.location==null || data.location==undefined){
        this.$toast.warning("Selecciona una  sucursal")
        return
      }
      if(this.types_form==1)
      {
        let location=this.$store.state.auth.locations.find((element)=>element.id==data.location)
   
       if(location != undefined || location != null)
       {
        if(location.catalogue_id==0||location.catalogue_id==null||location.catalogue_id==undefined)
        {
          this.$toast.warning("Esta sucursal no tiene un catalogo asignado.")
        }
        else
        {
          let resultCatalogues = await this.api_Get(
        "inventory/catalogues/details/" + location.catalogue_id
      );
      let data = await resultCatalogues.json();
      this.articlesCatalogue = data;
        }
       }

      }
      if(this.types_form==0)
      {
        this.loadingEntitiesDiscounts=true
        const responseRequest = await this.api_Post("accounting/search_entity_discount", {
        business_unit_id: data.business,
        location_id: data.location,
      });
      if (responseRequest.status == 200) {
        let data = await responseRequest.json();
          this.EntitiesDiscounts = data
   
      } else {
        this.$toast.error("¡Error al agregar!");
      }
      this.loadingEntitiesDiscounts=false
      }
    
      
    },
    async getData() {
      const request = await this.api_Get("income/discounts");
      const data = await request.json();

      if (request.status == 200) {
        this.discounts = data;
      }
    },
    getAfterDot(str) {
    // Encontrar el índice del primer punto en la cadena
    const dotIndex = str.indexOf('.');
    // Si hay un punto, retornar la parte después de él; de lo contrario, retornar la cadena vacía
    return dotIndex !== -1 ? str.substring(dotIndex + 1) : '';
}
,
  async  editeDiscountClient(item) {

    this.loadingEntityEdit=true
      this.is_new_Withholdings = false;

      this.selectedEntity={}
      this.selectedEntity.entity_id=item.entity_id
      this.selectedEntity.name=item.name
      this.selectedEntity.document_id_type_name=item.document_id_type_name
      this.selectedEntity.document_id=item.document_id
      
      this.firstValue= parseFloat( this.getAfterDot(item.from_percent_discount))
      this.onFirstValueChange(this.firstValue)
      this.secondValue= parseFloat(this.getAfterDot(item.to_percent_discount))
      this.defaultValue= parseFloat( this.getAfterDot(item.default_percent))
    this.lastDiscount={
      firstValue: this.firstValue,
      secondValue: this.secondValue,
      defaultValue: this.defaultValue

    }
      this.titleDialog = "Editar descuento de "  + item.name;
      this.newDiscounts = Object.assign({}, item);

      this.nameButon = "Actualizar";
      this.loadingEntityEdit=false
      this.dialogEdit = true;
  
    },
    newDiscount() {
      if(this.lastData.location==0||this.lastData.location==null||this.lastData.location==undefined)
      {
        this.$toast.warning("Selecciona una  sucursal")
        return
      }
      this.clearDialog();
      this.titleDialog = "Nuevo descuento en ";
      this.selectedEntity={}
      this.nameButon = "Guardar";
      this.dialogEdit = true;
    },
    clearDialog() {
     this.selectEntity = {};
     this.firstValue = null;
     this.secondValue = null;
     this.defaultValue = null;
   

    },
    async saveNewDiscountClient() {
      this.loadingSave = true;
      if( this.selectedEntity == null)
      {
        this.$toast.warning("Selecciona un cliente")
        return
      }
      if( this.firstValue == null)
      {
        this.$toast.warning("Selecciona inicio del porcentaje")
        return
      }
      if( this.secondValue == null)
      {
        this.$toast.warning("Selecciona final del porcentaje")
        return
      }
     
     
      if (this.is_new_Withholdings == true) {
        let datos = {
        entity_id: this.selectedEntity.entity_id,
        location_id: this.lastData.location,
        from_percent_discount: this.firstValue/100,
        to_percent_discount: this.secondValue/100,
        default_percent: this.defaultValue/100
   
      };
      const  responsePost = await this.api_Post("inventory/add_discount_entity", datos);
        if (responsePost.status === 200) {
          this.$toast.success("Descuento creado correctamente!");
          this.searchDiscount(this.lastData);
          this.dialogEdit = false;
        }
      } else {
        let edit_datos = {
        entity_id: this.selectedEntity.entity_id,
        location_id: this.lastData.location,
        last_from_percent_discount: this.lastDiscount.firstValue/100,
        last_to_percent_discount: this.lastDiscount.secondValue/100,
        last_default_percent: this.lastDiscount.defaultValue/100,
        from_percent_discount: this.firstValue/100,
        to_percent_discount: this.secondValue/100,
        default_percent: this.defaultValue/100
   
      };
  
      
      const   responsePut = await this.api_Put("inventory/update_discount_entity", edit_datos);
        if (responsePut.status === 200) {
          this.$toast.success("Descuento actualizado correctamente!");
          this.searchDiscount(this.lastData);
          this.dialogEdit = false;
        }
      }
  

      this.loadingSave = false;
    },
  },
};
</script>
